import { FuncionarioTranslate } from './funcionario.translate';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Funcionario } from 'src/app/classes/Funcionario';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';
import Swal from 'sweetalert2';
import { CustomToastyService } from 'src/app/theme/shared/components/toasty/custom-toasty.service';
import { EscalaTrabalho } from 'src/app/classes/EscalaTrabalho';
import { EscalaTrabalhoService } from 'src/app/services/escala-trabalho.service';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from 'src/app/utils/utils.service';
import { Location } from '@angular/common';
import { ColumnModel, SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { forkJoin } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { SyncGridComponent } from '../../shared-farm/sync-grid/sync-grid.component';
import { FormsFuncionarioComponent } from './forms-funcionario/forms-funcionario.component';

@Component({
  selector: 'app-funcionario',
  templateUrl: './funcionario.component.html',
  styleUrls: ['./funcionario.component.scss']
})
export class FuncionarioComponent extends FuncionarioTranslate implements OnInit {
  @ViewChild("gridFuncionarios", { static: false })
  gridFuncionarios: SyncGridComponent;

  @ViewChild("FormsFuncionario", { static: false })
    formsFuncionario: FormsFuncionarioComponent;

  funcionarios: Funcionario[];
  auxFuncionarios: Funcionario[];
  funcionario: Funcionario;
  id:number;
  inserindo: boolean = false;
  carregando: boolean = false;

  form: any;
  public isSubmit: boolean;
  textoBusca: string = "";
  perfilLogado: number = 0;

  escalasTrabalho: EscalaTrabalho[];
  funcionarioColumns: ColumnModel[] = [];
  desabilitarAcoes: boolean = false;
  removendo: boolean = false;
  duplicando: boolean = false;
  inativando: boolean = false;
  gridHeight: string = '79vh';
  selectionSettings: SelectionSettingsModel = { type: 'Multiple'}
  constructor(private funcionariosService: FuncionarioService, private escalaTrabalhoService: EscalaTrabalhoService,
              private route: ActivatedRoute,
              private router: Router,
              private storageService: StorageService,
              private toasty: CustomToastyService,
              private translate: TranslateService,
              private utils: UtilsService,
              private location: Location) {
                super(translate)
  }

  ngOnInit() {
    this.perfilLogado = this.storageService.getUsuario().Perfil;
    this.escalaTrabalhoService.getEscalaTrabalhos().subscribe(ret =>{
      this.escalasTrabalho = ret;
    });

    this.listarFuncionarios();
    this.configurarGrid()
  }

    configurarGrid(): void{
    this.funcionarioColumns = [
      { type: "checkbox", width: 50, showInColumnChooser: false},
      {
        field: "Nome",
        headerText: "Nome",
        type: "string",
        allowSorting: true,
      },
      {
        field: "Funcao",
        headerText: "Função",
        type: "string",
        allowSorting: true,
      },
      {
        field: "EscalaTrabalho.Descricao",
        headerText: "Escala de Trabalho",
        type: "string",
        allowSorting: true,
      },
      {
        field: "dataAlteracaoStr",
        headerText: "Ult. Mod.",
        type: "string",
        allowSorting: true,
      },
      {
        field: "UsuarioAlteracaoDesc",
        headerText: "Resp. Mod.",
        type: "string",
        allowSorting: true,
      },
      {
        field: "descAtivo",
        headerText: "Status",
        allowSorting: true,
        disableHtmlEncode: false,
        type: 'boolean',
        valueAccessor: (_field: string, _data: any): any => {
          return this.badgeStatusUsuario(_data.Ativo);
        }
      },
    ]
    this.ajustarTamanhoGrid();
  }

    ajustarTamanhoGrid(): void {
    const navbar = document.querySelector('app-nav-bar.navbar.pcoded-header') as HTMLElement
    const groupdroparea = document.querySelector('div.e-groupdroparea.e-lib.e-droppable.e-draggable') as HTMLElement
    const toolbar = document.querySelector('div.custom-toolbar.justify-content-between') as HTMLElement
    const title = document.querySelector('app-funcionario h5.titulo') as HTMLElement
    const altura = window.innerHeight - navbar.offsetHeight - groupdroparea.offsetHeight - toolbar.offsetHeight - title.offsetHeight - 70
    this.gridHeight = `${altura}px`
  }

  badgeStatusUsuario(ativo: boolean): string {
    return ativo ? '<span class="badge badge-light-success custom-badge-grid">Ativo</span>' : '<span class="badge badge-light-danger custom-badge-grid">Inativo</span>'
  }

  confirmaInativar(): void{
    if(!this.ValidarSelectUmOuMais) return
    var funcionarios = this.gridFuncionarios.getSelectedRecords();
    if (funcionarios.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return;
    }
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os funcionarios selecionados serão inativados!",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Inativar funcionarios",
    }).then((response) => {
      if (!response.dismiss) {
        this.inativar(funcionarios);
      }
    });

  }

  inativar(funcionarios: Funcionario[]): void{
    this.inativando = true
    this.funcionariosService.inativar(funcionarios.map(p => p.Id))
    .subscribe(() => {
        this.utils.handleSuccess("Funcionários inativados com sucesso")
        this.listarFuncionarios();
        this.inativando = false
      },
      (err) => {
        this.utils.getErro(err)
        this.inativando = false
      }
    )
  }

  confirmaDuplicar(): void {
    var funcionarios = this.gridFuncionarios.getSelectedRecords();
    if(!this.ValidarSelectUmOuMais()) return
    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os Funcionarios selecionados serão duplicados!",
      type: "warning",
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Duplicar Funcionarios",
    }).then((response) => {
      if (!response.dismiss) {
        this.duplicar(funcionarios);
      }
    });
  }

  duplicar(funcionarios: Funcionario[]): void {
    this.duplicando = true
    this.funcionariosService.duplicar(funcionarios.map(p => p.Id))
    .subscribe(() => {
        this.utils.handleSuccess("Funcionarios duplicados com sucesso")
        this.listarFuncionarios();
        this.duplicando = false
      },
      (err) => {
        this.utils.getErro(err)
        this.duplicando = false
      }
    )
  }

  doubleClick(funcionario: Funcionario){
    this.editar(funcionario)
  }


  confirmRemover() {
      if(!this.utils.verificarPermissaoUsuario('ExcluirFuncionario'))
        return;

    var funcionarios = this.gridFuncionarios.getSelectedRecords();
    if(!this.ValidarSelectUmOuMais()) return

    Swal.fire({
      title: "Você tem certeza desta ação?",
      text: "Os funcionários selecionados serão excluidas, esta ação não poderá ser desfeita!",
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
        if (!willDelete.dismiss)
          this.removerFuncionarios(funcionarios)
      });
  }

  removerFuncionarios(funcionarios: Funcionario[]){
    this.removendo = true;
    this.funcionariosService.deleteFuncionarios(funcionarios.map(p => p.Id)).subscribe(
      res => {
        console.debug('res: ', res)

        // Verificar se há erros no retorno (Dictionary<int, string>)
        if (res && typeof res === 'object' && Object.keys(res).length > 0) {
          // Há erros - exibir quais variedades falharam
          const erros: string[] = [];
          Object.keys(res).forEach(id => {
            const funcionario = funcionarios.find(v => v.Id.toString() === id);
            const nomeFuncionario = funcionario ? funcionario.Nome : `ID ${id}`;
            erros.push(`<b>${nomeFuncionario}</b>: ${res[id]}`);
          });
          var msgInfo = `<br/><br/><br/><b>Não é possível excluir funcionários que estão sendo utilizados, mas você pode inátiva-los.</b>`
          Swal.fire({
            title: 'Erro ao excluir funcionários',
            html: `Os seguintes funcionários não puderam ser excluídos:<br><br><div class="pl-6 " style="text-align: left;">${erros.join('<br>')} ${msgInfo}</div>`,
            type: 'error',
            showCloseButton: true,
            confirmButtonText: 'OK'
          });
        } else {
          // Sucesso - todas as funcionários foram excluídas
          this.utils.handleSuccess("Funcionários excluídos com sucesso");
        }

        this.listarFuncionarios();
        this.removendo = false;
      },
      err => {
        this.utils.getErro(err);
        this.removendo = false;
    });

  }

  novo_(): void{
    if(!this.utils.verificarPermissaoUsuario('IncluirFuncionario'))
      return;

    this.utils.handleWarning("Não implementado")
  }

  editar_(): void{
    if(!this.utils.verificarPermissaoUsuario('EditarFuncionario'))
      return;
    this.utils.handleWarning("Não implementado")
  }

  selecionarFuncionario() {
    this.configurarTraducao();
    this.carregando = true;
    this.funcionariosService.getFuncionario(this.id).subscribe(res =>{
      this.funcionario = new Funcionario();
      this.funcionario = res;
      this.carregando = false;
    },
    ex =>{
      this.utils.getErro(ex);
      this.carregando = false;
    })
  }

  listarFuncionarios(){
    this.configurarTraducao();
    this.carregando = true;
    this.funcionariosService.listarTodos().subscribe(
      res => {
        this.funcionarios = res.map(u => Object.assign(new Funcionario(), u));;
        this.auxFuncionarios = res;
        this.carregando = false;
      },
      err => {
        this.utils.getErro(err);
        this.carregando = false;
      });
  }

  novo(): void{
    if(!this.utils.verificarPermissaoUsuario('IncluirFuncionario'))
      return;
      this.formsFuncionario.abrirModal();
  }

  editar(funcionario: any = null): void{
    if(!this.utils.verificarPermissaoUsuario('EditarFuncionario'))
      return;

    let obj;

    if(!funcionario){
        var funcionarios = this.gridFuncionarios.getSelectedRecords();
        if(!this.ValidarSelectApenasUm()) return;

        obj = {...funcionarios[0]};
    }
    else
        obj = {...funcionario}
    this.formsFuncionario.abrirModal(obj);
  }

  finalizarSaveFuncionario(): void{
    this.listarFuncionarios();
  }

  save(form: any) {
    this.configurarTraducao();
    if (!form.valid) {
      this.isSubmit = true;
      return;
    }
    this.carregando = true;

    if(this.funcionario.Id > 0)
      this.funcionariosService.putFuncionario(this.funcionario.Id, this.funcionario).subscribe(
        res => {
          this.toasty.show(this.FEITO, this.FUNCIONARIO_ALTERADO, 'success');
          this.carregando = false;
        },
        err => {
          this.utils.getErro(err);
          this.carregando = false;
        });
    else
      this.funcionariosService.postFuncionario(this.funcionario).subscribe(
        res => {
          this.toasty.show(this.FEITO, this.FUNCIONARIO_CADASTRADO, 'success');
          this.carregando = false;
          this.cancelar();
        },
        err => {
          this.utils.getErro(err);
          this.carregando = false;
        });

  }

  excluir(grupooperacaoId: number, nome: string) {
    if(!this.utils.verificarPermissaoUsuario('ExcluirFuncionario'))
      return;
    this.DELETAR_PARAM = this.translate.instant('DELETAR_PARAM', {value: nome});
    this.configurarTraducao();
    Swal.fire({
      title: this.DELETAR_PARAM,
      text: this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: this.CANCELAR,
      confirmButtonText: this.SIM,
    }).then((willDelete) => {
        if (willDelete.dismiss) {

        } else {
          this.carregando = true;
          this.funcionariosService.deleteFuncionario(grupooperacaoId).subscribe(
            res => {
              this.toasty.show(this.FEITO, this.FUNCIONARIO_DELETADO, 'success');
              this.listarFuncionarios();
              this.carregando = false;
            },
            err => {
              this.utils.getErro(err);
              this.carregando = false;
            });
        }
      });
  }

  filtrarFuncionarios(){
    this.funcionarios = this.auxFuncionarios.filter(x =>
      x.Nome.toUpperCase().includes(this.textoBusca.toUpperCase()) ||
      x.Funcao.toUpperCase().includes(this.textoBusca.toUpperCase()) ||
      x.Id.toString().includes(this.textoBusca.toUpperCase())
      );
  }

  cancelar(){
    this.router.navigate(['/cadastros/funcionario']);
  }

  getEscalaTrabalho(id: number) : EscalaTrabalho {
    if (!this.escalasTrabalho)
      return null;

    let escalas = this.escalasTrabalho.filter(x =>
      x.Id==id
    );

    return escalas.length > 0 ? escalas[0] : new EscalaTrabalho();
  }
  ValidarSelectUmOuMais(): boolean {
    var funcionarios = this.gridFuncionarios.getSelectedRecords();
    if (funcionarios.length == 0) {
      this.utils.handleWarning("Selecione um ou mais itens para continuar");
      return false;
    }

    return true;
  }

  ValidarSelectApenasUm(): boolean {
    var funcionarios = this.gridFuncionarios.getSelectedRecords();
    if (funcionarios.length == 0) {
      this.utils.handleWarning("Selecione um item para continuar");
      return false;
    }
    if(funcionarios.length > 1){
      this.utils.handleWarning("Selecione apenas um item para continuar");
      return false;
    }
    return true;
  }


  configurarTraducao() {
    this.SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA = this.translate.instant('SE_DELETAR_ESTA_ACAO_NAO_PODERA_SER_DESFEITA');
    this.CANCELAR = this.translate.instant('CANCELAR');
    this.SIM = this.translate.instant('SIM');
    this.FEITO = this.translate.instant('FEITO');
    this.FUNCIONARIO_DELETADO = this.translate.instant('FUNCIONARIO_DELETADO');
    this.ERRO = this.translate.instant('ERRO');
    this.FUNCIONARIO_ALTERADO = this.translate.instant('FUNCIONARIO_ALTERADO');
    this.FUNCIONARIO_CADASTRADO = this.translate.instant('FUNCIONARIO_CADASTRADO');
  }
}
